/* js/header.js */

/* Set the width of the sidebar to 250px and the left margin of the page content to 250px */
function openNav() {
  document.getElementById("sidebar").style.width = "450px";
  document.getElementById("sidebar").classList.add("open");
  $(".fixed-header").css("z-index", "450");
  $('body').css('overflow', 'hidden');
}

/* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
function closeNav() {
  document.getElementById("sidebar").style.width = "0";
  document.getElementById("sidebar").classList.remove("open");
  $(".fixed-header").css("z-index", "499");
  $('body').css('overflow', 'auto');
}

function stopDefAction(evt) {
  evt.preventDefault();
}

$('.mainnav__sidebar ul li a').click(function(){
  var id = $(this).attr('id');
  $('nav ul li ul.item-show-'+id).toggleClass("show");
  $(this).find("svg").toggleClass("rotate");
});

$('nav ul li').click(function(){
  $(this).addClass("active").siblings().removeClass("active");
});



// DOMContentLoaded  end



